import Homepage from "./Homepage";
import AboutPage from "./AboutPage";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAHELErxo3PK_iFSjhoOhrAnM0drd7AsLI",
  authDomain: "portfolio-21893.firebaseapp.com",
  projectId: "portfolio-21893",
  storageBucket: "portfolio-21893.appspot.com",
  messagingSenderId: "947713508040",
  appId: "1:947713508040:web:8079b55a3c6fe66d419bfd",
};

initializeApp(firebaseConfig);

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" Component={Homepage} />
        <Route exact path="/about" Component={AboutPage} />
      </Routes>
    </Router>
  );
}

export default App;
